import {computed, ref} from 'vue';
import {defineStore, storeToRefs} from 'pinia';
import {useAbortableApi} from '#imports';
import {withCleanup} from '@malt/utils';
import {projectInformationEndpoints} from '~/registry';
import type {PatchedProjectActivityResource} from '../types';
import {useProjectInformationStore} from '@/common/stores/project.store';

export const useActivityStore = defineStore('activity', () => {
    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);

    const pendingProjectActivity = ref(false);

    // Keep to mock
    // const projectActivity = ref<PatchedProjectActivityResource | null>({
    //     pendingActions: [
    //         {actionType: 'ADD_PURCHASE_ORDER', dueDate: new Date()},
    //         {actionType: 'APPROVE_CONTRACT', dueDate: subDays(new Date(), 4), extraData: {amendmentQuoteId: '7777'}},
    //         // {actionType: 'CONFIRM_INVOICED_PROJECT_COMPLETION', dueDate: new Date('01-08-2024')},
    //         // {actionType: 'CONFIRM_PREPAID_PROJECT_COMPLETION', dueDate: new Date('01-08-2024')},
    //         // {actionType: 'LEAVE_APPRAISAL', dueDate: new Date('01-08-2024')},
    //         // {actionType: 'LOT_PAYMENT_OVERDUE', dueDate: new Date('01-08-2024'), extraData: {dueSince: '-P4D', lotId: 'ijjrilz', month: '5'}},
    //         // {actionType: 'PAY_PROJECT', dueDate: new Date('01-08-2024')},
    //         // {actionType: 'PAY_PROJECT_LOT', dueDate: new Date('01-08-2024'), extraData: {lotId: 'efkzef', month: '2', dueFrom: 'P10D'}},
    //         // {actionType: 'PAYMENT_OVERDUE', dueDate: new Date('01-08-2024'), extraData: {lotId: 'efkzzefef', month: '7', dueSince: '-P397D'}},
    //         // {actionType: 'PREPAY_PROJECT', dueDate: new Date('01-08-2024')},
    //         // {actionType: 'REVIEW_EXPENSE_REPORT', dueDate: new Date('01-08-2024')},
    //         // {actionType: 'REVIEW_ACTIVITY_REPORT', dueDate: new Date('01-08-2024'), extraData: {lotId: 'efkzefzef', month: '11'}},
    //     ],
    //     activityState: 'NO_ACTION_YET',
    //     pastEvents: [],
    // });
    const projectActivity = ref<PatchedProjectActivityResource | null>(null);

    const pendingActions = computed(() => projectActivity.value?.pendingActions);
    const pastEvents = computed(() => projectActivity.value?.pastEvents);
    const activityState = computed(() => projectActivity.value?.activityState);

    const {execute: getProjectActivity, abort: abortProjectActivity, aborted} = useAbortableApi(projectInformationEndpoints, 'getProjectActivity');

    async function fetchProjectActivity(projectId?: string) {
        try {
            const id = projectId ?? useProjectInformationStore().projectInformation.projectId;
            if (id) {
                abortProjectActivity();
                pendingProjectActivity.value = true;
                projectActivity.value = (await getProjectActivity({
                    projectId: id,
                })) as PatchedProjectActivityResource;
            }
        } catch (e) {
        } finally {
            if (!aborted.value) {
                pendingProjectActivity.value = false;
            }
        }
    }

    return withCleanup({
        fetchProjectActivity,
        projectActivity,
        pendingActions,
        pastEvents,
        activityState,
        pendingProjectActivity,
    });
});
